module.exports = __webpack_public_path__ + "img/zctp.75297e2e.jpg";